import React from "react";
import type { Meta, StoryObj } from "@storybook/react";
import IdVerificationPending from "../../screens/auth/IdVerificationPending";

const StoryComponent = () => {
    return <IdVerificationPending />;
};

const meta = {
    title: "Screens/ID Verification Pending",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
